<router-outlet></router-outlet>
<app-sofia-invite />
